import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";

export default function NotFound() {
  const { t } = useTranslation("nav");
  return (
    <div
      data-testid="not-found-page"
      className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-6 text-center"
    >
      <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-slate-400">
        404
      </span>
      <h1 className="mt-4 font-display text-4xl font-semibold tracking-tight text-slate-900">
        {t("notFound.title")}
      </h1>
      <p className="mt-3 max-w-sm text-sm text-slate-500">{t("notFound.body")}</p>
      <Link
        to="/dashboard"
        data-testid="not-found-cta"
        className="mt-8 inline-flex items-center gap-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-800"
      >
        <Home className="h-4 w-4" strokeWidth={1.75} /> {t("notFound.cta")}
      </Link>
    </div>
  );
}
